import { useTranslation } from "react-i18next";

interface FaqItem { q: string; a: string; }

export default function SEOFaq() {
  const { t } = useTranslation();
  const faqs = (t("faq.items", { returnObjects: true }) as FaqItem[]) || [];

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-blue-50" itemScope itemType="https://schema.org/FAQPage">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t("faq.title")}
          </h2>
          <p className="text-lg text-gray-600">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-6 border border-gray-200"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">{faq.q}</h3>
              <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                <div className="text-gray-700 leading-relaxed" itemProp="text">{faq.a}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">{t("faq.moreQuestions")}</p>
          <button className="bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors">
            {t("faq.contactExperts")}
          </button>
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map((faq) => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": { "@type": "Answer", "text": faq.a }
          }))
        })
      }} />
    </section>
  );
}
